export const typography = {
  fonts: {
    body: 'Barlow, sans-serif',
  },
  fontSizes: {
    'xs': '13px',
    'sm': '15px',
    'md': '16px',
    'lg': '18px',
    'xl': '20px',
    '2xl': '24px',
    '3xl': '28px',
    '4xl': '36px',
    '5xl': '48px',
    '6xl': '64px',
  },
};
